export const TREATMENT_INFO = {
  'Кастрация': {
    title: 'Овариохистеректомия (кастрация)',
    description: 'Бяха внимателно премахнати яйчниците и матката с цел превенция на заболявания и неконтролируемо размножаване. Оперативната рана е с минимален размер.',
    care: 'Следете раната за зачервяване. Осигурете тишина и топлина днес.'
  },
  'Ваксина': {
    title: 'Ваксинация',
    description: 'Вашето животно беше ваксинирано за защита от основни инфекциозни заболявания.',
    care: 'Възможно е леко понижена активност в следващите 24 часа.',
  },
  'Външно': {
    title: 'Външно обезпаразитяване',
    description: 'Приложен е препарат срещу бълхи, кърлежи и подкожни паразити.'
  },
  'Вътрешно': {
    title: 'Вътрешно обезпаразитяване',
    description: 'Приложен е препарат срещу ендопаразити (глисти и тении).'
  }
};